import { useEffect, useState } from "react";

export default function useStripeCallback(
  onSuccess: () => Promise<void>,
  onError: (error: any) => void
) {
  const [success, setSuccess] = useState(false);
  useEffect(() => {
    // https://local.staging-getnexar.com:3000/mynexar?
    // setup_intent=seti_*********
    // &setup_intent_client_secret=seti_*******_secret_***********
    // &redirect_status=succeeded
    // #/connect/subscriptions/TEST-ID-INACTIVE-CANCELLED
    const queryParams = new URLSearchParams(window.location.search);
    const redirectStatus = queryParams.get("redirect_status"); // Replace 'paramName' with your parameter name

    if (redirectStatus === "succeeded") {
      window.history.replaceState(
        {},
        document.title,
        window.location.pathname + window.location.hash
      );

      onSuccess();
      setSuccess(true);
    } else if (typeof redirectStatus === "string") {
      onError("Failed to complete the payment");
    }
  }, []);

  return success;
}
